import Utils from "../../../../../shared/utils"

export const IMAGE_URL = Utils.buildProductPageImageLink("mort/complete-mort/first-section.svg")

export const MAIN_TITLE_ICON = Utils.buildProductPageImageLink("icons/hands-house-icon.svg")